import { defaultProposalStyle } from './proposalAppearanceStyle';

export const demoProposal: Proposal = {
  id: 'demo-proposal',
  name: 'Showcase proposal for mobile application',
  currency: 'EUR',
  publishStatus: 'published',
  acceptanceStatus: 'pending',
  currentPreset: 'default',
  vatPercentage: 25,
  creationDateTime: 1611842071650,
  displayDateTime: 1709593200000,
  validUntilDateTime: 1710802800000,
  client: {
    email: 'nextbig@client.com',
    vatId: 'HR123456789',
    id: 'vApQfCoei2BOqB64ugON',
    name: 'Next Big Client LTD',
    phone: '+01212555123',
    address: {
      addressOne: 'Trg Ante Starčevića',
      addressTwo: '',
      city: 'Osijek',
      state: '',
      country: 'Croatia',
      postalCode: '31000',
    },
    createdAt: 1694533361612,
  },
  customTags: [],
  companyInfo: {
    id: 'settings',
    name: 'PROTOTYP d.o.o.',
    companyImage:
      'https://firebasestorage.googleapis.com/v0/b/propoze-production.appspot.com/o/gJM2L94rwDfKaYNzfBeJ6uKyxbk2%2Fsettings%2Fsettings%2FcompanyImage?alt=media&token=a66c9e06-4376-4b1c-9647-11d9fcac0464',
    isOnboardingInProgress: false,
    address: {
      postalCode: '31000',
      addressTwo: '',
      city: 'Osijek',
      country: 'Croatia',
      state: '',
      addressOne: 'Ulica Bartola Kašića 7',
    },
    tax: {
      vatId: '69410380024',
      vatPercentage: 25,
    },
    storageLeftInBytes: 1073741824,
  },
  visibility: 'public',
  style: defaultProposalStyle,
  ownerNotifiedDate: null,
  segments: [
    {
      subtitle:
        'Discovery sprint will involve development, consultant and design teams on-site workshops. The goal of the Discovery Sprint is to acquire all relevant project info and create a realistic development plan and break down the project scope into achievable sprints.',
      title: 'Discovery sprint',
      type: 'heading',
    },
    {
      content:
        '[{"children":[{"text":"Technical Discovery ","bold":true}],"type":"paragraph"},{"children":[{"children":[{"text":"API and data discovery"}],"type":"li"},{"children":[{"text":"Technical specification creation"}],"type":"li"},{"children":[{"text":"Working with current data"}],"type":"li"},{"children":[{"text":"Project architecture design"}],"type":"li"},{"type":"li","children":[{"text":"Interface planning"}]}],"type":"ul"}]',
      pricePerUnit: 420,
      unit: {
        id: 'Iz7f2nZwe8sm9QLfiuv9',
        name: 'Day',
        index: 0,
      },
      type: 'service',
      quantity: 3,
      service: {
        id: 'uKMwQlUef8RvV23AGxo2',
        name: 'Project Planning',
        createdAt: +new Date(),
      },
      discount: 0,
    },
    {
      discount: 0,
      type: 'service',
      pricePerUnit: 420,
      unit: {
        name: 'Day',
        id: 'Iz7f2nZwe8sm9QLfiuv9',
        index: 1,
      },
      quantity: 2,
      service: {
        id: 'uKMwQlUef8RvV23AGxo2',
        name: 'Project Planning',
        createdAt: +new Date(),
      },
      content:
        '[{"children":[{"text":"Project plan creation","bold":true}],"type":"paragraph"},{"type":"ul","children":[{"children":[{"text":"Defining user stories and critical path’s"}],"type":"li"},{"children":[{"text":"Defining acceptance criteria in sync with the dev team"}],"type":"li"}]},{"type":"paragraph","children":[{"text":""}]}]',
    },
    {
      type: 'text',
      content:
        '[{"children":[{"text":"User stories are short, specific, easy to understand statements used to ensure that design and development are aligned around a common purpose - addressing user needs. The focus of a user story is on the goal that the user wants to accomplish by using the digital product.","italic":true}],"type":"paragraph"}]',
    },
    {
      title: 'UX design phase',
      subtitle:
        'UX phase ensures the creation of product that provides meaningful and relevant experiences to users. Its output will be creation wireframes interconnected into clickable prototype.',
      type: 'heading',
    },
    {
      pricePerUnit: 420,
      unit: {
        id: 'Iz7f2nZwe8sm9QLfiuv9',
        name: 'Day',
        index: 2,
      },
      service: {
        id: 'nwxRX2RwkCiBNCWPZhC0',
        name: 'User Interface Design',
        createdAt: +new Date(),
      },
      type: 'service',
      discount: 0,
      quantity: 3,
      content:
        '[{"type":"paragraph","children":[{"text":"Start screens wireframes","bold":true}]},{"children":[{"type":"li","children":[{"text":"Loading screen / Welcome screen"}]},{"type":"paragraph","children":[{"text":"﻿"}]}],"type":"ul"},{"type":"paragraph","children":[{"text":"Onboarding","bold":true}]},{"type":"ul","children":[{"children":[{"text":"Introduction screen"}],"type":"li"},{"type":"li","children":[{"text":"Technique screen"}]},{"type":"li","children":[{"text":"Process and goal screen"}]}]},{"type":"paragraph","children":[{"text":"﻿"}]},{"children":[{"text":"User authentication & login wireframes","bold":true}],"type":"paragraph"},{"children":[{"children":[{"text":"Login"}],"type":"li"},{"children":[{"text":"Registration"}],"type":"li"},{"children":[{"text":"Password reset/Forgot password"}],"type":"li"},{"children":[{"text":"E-mail confirmation screen"}],"type":"li"},{"children":[{"text":"Chose avatar screen"}],"type":"li"}],"type":"ul"},{"children":[{"text":"﻿"}],"type":"paragraph"},{"type":"paragraph","children":[{"bold":true,"text":"Introductory screens wireframes"}]},{"type":"ul","children":[{"children":[{"text":"Introductory session screen"}],"type":"li"},{"children":[{"text":"Introductory session player screen"}],"type":"li"},{"children":[{"text":"Multichoice question screen screen"}],"type":"li"},{"children":[{"text":"Multichoice question stats screen"}],"type":"li"},{"children":[{"text":"List of comments (social wall)"}],"type":"li"},{"children":[{"text":"Add comment"}],"type":"li"}]},{"children":[{"text":"﻿"}],"type":"paragraph"},{"type":"paragraph","children":[{"bold":true,"text":"Dynamic screens wireframes"}]},{"type":"ul","children":[{"type":"li","children":[{"text":"Dynamic content list screen"}]},{"children":[{"text":"Single Dynamic content  screen"}],"type":"li"},{"children":[{"text":"Single session player screen"}],"type":"li"},{"children":[{"text":"List of comments (social wall)"}],"type":"li"},{"children":[{"text":"Add comment"}],"type":"li"}]},{"children":[{"text":"﻿"}],"type":"paragraph"},{"type":"paragraph","children":[{"text":"Static content wireframes","bold":true}]},{"children":[{"children":[{"text":"Education"}],"type":"li"},{"children":[{"text":"Logistics of use"}],"type":"li"},{"children":[{"text":"FAQ"}],"type":"li"}],"type":"ul"},{"children":[{"text":"﻿"}],"type":"paragraph"},{"children":[{"text":"Profile screens wireframes","bold":true}],"type":"paragraph"},{"children":[{"children":[{"text":"Settings screen"}],"type":"li"},{"type":"li","children":[{"text":"User profile screen"}]},{"children":[{"text":"Invoice list screen"}],"type":"li"}],"type":"ul"}]',
    },
    {
      title: 'UI Phase — Hi-fidelity mockups',
      type: 'heading',
      subtitle:
        'In the UI phase, we create a hi-fidelity design of the wireframe solution. The next items in the offer refer to the UI design of the app screens.',
    },
    {
      pricePerUnit: 420,
      service: {
        name: 'User Interface Design',
        id: 'nwxRX2RwkCiBNCWPZhC0',
        createdAt: +new Date(),
      },
      type: 'service',
      discount: 0,
      content:
        '[{"children":[{"bold":true,"text":"Start screens wireframes"}],"type":"paragraph"},{"type":"ul","children":[{"type":"li","children":[{"text":"Loading screen / Welcome screen"}]},{"type":"paragraph","children":[{"text":"﻿"}]}]},{"children":[{"text":"Onboarding","bold":true}],"type":"paragraph"},{"children":[{"children":[{"text":"Introduction screen"}],"type":"li"},{"children":[{"text":"Technique screen"}],"type":"li"},{"children":[{"text":"Process and goal screen"}],"type":"li"}],"type":"ul"},{"children":[{"text":"﻿"}],"type":"paragraph"},{"children":[{"text":"User authentication & login wireframes","bold":true}],"type":"paragraph"},{"children":[{"type":"li","children":[{"text":"Login"}]},{"children":[{"text":"Registration"}],"type":"li"},{"type":"li","children":[{"text":"Password reset/Forgot password"}]},{"type":"li","children":[{"text":"E-mail confirmation screen"}]},{"children":[{"text":"Chose avatar screen"}],"type":"li"}],"type":"ul"},{"children":[{"text":"﻿"}],"type":"paragraph"},{"children":[{"text":"Introductory screens wireframes","bold":true}],"type":"paragraph"},{"children":[{"children":[{"text":"Introductory session screen"}],"type":"li"},{"children":[{"text":"Introductory session player screen"}],"type":"li"},{"children":[{"text":"Multichoice question screen screen"}],"type":"li"},{"children":[{"text":"Multichoice question stats screen"}],"type":"li"},{"type":"li","children":[{"text":"List of comments (social wall)"}]},{"children":[{"text":"Add comment"}],"type":"li"}],"type":"ul"},{"children":[{"text":"﻿"}],"type":"paragraph"},{"type":"paragraph","children":[{"text":"Dynamic screens wireframes","bold":true}]},{"children":[{"type":"li","children":[{"text":"Dynamic content list screen"}]},{"type":"li","children":[{"text":"Single Dynamic content  screen"}]},{"type":"li","children":[{"text":"Single session player screen"}]},{"type":"li","children":[{"text":"List of comments (social wall)"}]},{"type":"li","children":[{"text":"Add comment"}]}],"type":"ul"},{"children":[{"text":"﻿"}],"type":"paragraph"},{"children":[{"bold":true,"text":"Static content wireframes"}],"type":"paragraph"},{"children":[{"type":"li","children":[{"text":"Education"}]},{"children":[{"text":"Logistics of use"}],"type":"li"},{"children":[{"text":"FAQ"}],"type":"li"}],"type":"ul"},{"children":[{"text":"﻿"}],"type":"paragraph"},{"children":[{"text":"Profile screens wireframes","bold":true}],"type":"paragraph"},{"children":[{"children":[{"text":"Settings screen"}],"type":"li"},{"type":"li","children":[{"text":"User profile screen"}]},{"type":"li","children":[{"text":"Invoice list screen"}]}],"type":"ul"}]',
      quantity: 12,
      unit: {
        id: 'Iz7f2nZwe8sm9QLfiuv9',
        name: 'Day',
        index: 3,
      },
    },
    {
      type: 'heading',
      subtitle:
        'React Native mobile development for iOS and Android. Development sprints are split into bi-weekly sprints with timeline overview and at the end of each sprint, staging build is sent to the client.',
      title: 'Development phase',
    },
    {
      content:
        '[{"children":[{"bold":true,"text":"Project setup:"}],"type":"paragraph"},{"children":[{"type":"li","children":[{"text":"Initial project setup for iOS and Android devices"}]},{"children":[{"text":"Logic for communication with backend api (Firebase)"}],"type":"li"},{"children":[{"text":"Mobile navigation"}],"type":"li"},{"children":[{"text":"Splash screen and app icons"}],"type":"li"}],"type":"ul"}]',
      service: {
        name: 'Mobile Development',
        id: 'TPWP2euy6C9bENATt6gF',
        createdAt: +new Date(),
      },
      discount: 0,
      pricePerUnit: 420,
      type: 'service',
      unit: {
        id: 'Iz7f2nZwe8sm9QLfiuv9',
        name: 'Day',
        index: 4,
      },
      quantity: 6,
    },
    {
      pricePerUnit: 420,
      service: {
        name: 'Mobile Development',
        id: 'TPWP2euy6C9bENATt6gF',
        createdAt: +new Date(),
      },
      type: 'service',
      unit: {
        id: 'Iz7f2nZwe8sm9QLfiuv9',
        name: 'Day',
        index: 5,
      },
      quantity: 6,
      content:
        '[{"children":[{"text":"User authentication & login","bold":true}],"type":"paragraph"},{"children":[{"type":"li","children":[{"text":"Login"}]},{"type":"li","children":[{"text":"Registration"}]},{"children":[{"text":"Password reset/Forgot password"}],"type":"li"},{"children":[{"text":"E-mail confirmation after registration"}],"type":"li"},{"type":"li","children":[{"text":"Authentication provider "}]},{"children":[{"text":"Social login (Facebook and Google)"}],"type":"li"}],"type":"ul"}]',
      discount: 0,
    },
    {
      unit: {
        name: 'Day',
        id: 'Iz7f2nZwe8sm9QLfiuv9',
        index: 6,
      },
      service: {
        id: 'TPWP2euy6C9bENATt6gF',
        name: 'Mobile Development',
        createdAt: +new Date(),
      },
      type: 'service',
      content:
        '[{"children":[{"text":"Onboarding flow","bold":true}],"type":"paragraph"},{"type":"ul","children":[{"type":"li","children":[{"text":"Registration Onboarding"}]},{"children":[{"text":"Subscription Onboarding"}],"type":"li"}]}]',
      discount: 0,
      pricePerUnit: 420,
      quantity: 3,
    },
    {
      pricePerUnit: 420,
      type: 'service',
      discount: 0,
      service: {
        id: 'TPWP2euy6C9bENATt6gF',
        name: 'Mobile Development',
        createdAt: +new Date(),
      },
      quantity: 7,
      content:
        '[{"children":[{"bold":true,"text":"User Profile"}],"type":"paragraph"},{"type":"ul","children":[{"type":"li","children":[{"text":"User profile information and styling"}]},{"type":"li","children":[{"text":"Edit options for user profile fields"}]},{"type":"li","children":[{"text":"Profile image upload from a device memory or camera"}]},{"children":[{"text":"Add avatar (Avatar Picker + Storage integration)"}],"type":"li"}]}]',
      unit: {
        name: 'Day',
        id: 'Iz7f2nZwe8sm9QLfiuv9',
        index: 7,
      },
    },
    {
      pricePerUnit: 420,
      content:
        '[{"type":"paragraph","children":[{"bold":true,"text":"Podcast player"}]},{"children":[{"type":"li","children":[{"text":"Audio player implementation (Custom designed in-app media player)"}]},{"children":[{"text":"Custom, subtle animations"}],"type":"li"},{"type":"li","children":[{"text":"Audio track metadata (Track title, short description, track length"}]},{"children":[{"text":"Giving access to users to the new tracks when "}],"type":"li"}],"type":"ul"}]',
      service: {
        id: 'TPWP2euy6C9bENATt6gF',
        name: 'Mobile Development',
        createdAt: +new Date(),
      },
      type: 'service',
      quantity: 10,
      unit: {
        name: 'Day',
        id: 'Iz7f2nZwe8sm9QLfiuv9',
        index: 8,
      },
      discount: 0,
    },
    {
      unit: {
        name: 'Day',
        id: 'Iz7f2nZwe8sm9QLfiuv9',
        index: 9,
      },
      discount: 0,
      type: 'service',
      pricePerUnit: 420,
      quantity: 8,
      service: {
        name: 'Mobile Development',
        id: 'TPWP2euy6C9bENATt6gF',
        createdAt: +new Date(),
      },
      content:
        '[{"children":[{"bold":true,"text":"In-app purchase"}],"type":"paragraph"},{"type":"ul","children":[{"type":"li","children":[{"text":"Intro screen  "}]},{"type":"li","children":[{"text":"Session listing (audio track) categories implementation"}]},{"children":[{"text":"Session Details screen"}],"type":"li"},{"children":[{"text":"Session summary screen"}],"type":"li"},{"children":[{"text":"In app purchase implementation"}],"type":"li"}]},{"children":[{"text":"﻿"}],"type":"paragraph"},{"type":"paragraph","children":[{"text":"Misc","bold":true}]},{"type":"ul","children":[{"type":"li","children":[{"text":"Static pages"}]},{"type":"li","children":[{"text":"Contact form"}]}]}]',
    },
    {
      type: 'service',
      quantity: 3,
      service: {
        id: 'TPWP2euy6C9bENATt6gF',
        name: 'Mobile Development',
        createdAt: +new Date(),
      },
      discount: 0,
      content:
        '[{"type":"paragraph","children":[{"bold":true,"text":"Push notifications:"}]},{"children":[{"type":"li","children":[{"text":"Daily reminders"}]},{"type":"li","children":[{"text":"Ability to send custom push notification"}]}],"type":"ul"}]',
      pricePerUnit: 420,
      unit: {
        name: 'Day',
        id: 'Iz7f2nZwe8sm9QLfiuv9',
        index: 10,
      },
    },
    {
      service: {
        id: 'HrTfzul9A4TrhBvqVWgx',
        name: 'Web Development',
        createdAt: +new Date(),
      },
      type: 'service',
      discount: 0,
      content:
        '[{"children":[{"text":"CMS implementation","bold":true}],"type":"paragraph"},{"type":"ul","children":[{"children":[{"text":"adding audio files"}],"type":"li"},{"type":"li","children":[{"text":"adding audio categories"}]},{"children":[{"text":"user management"}],"type":"li"},{"children":[{"text":"manage user comments"}],"type":"li"},{"type":"li","children":[{"text":"edit static pages & onboarding"}]}]}]',
      unit: {
        id: 'Iz7f2nZwe8sm9QLfiuv9',
        name: 'Day',
        index: 11,
      },
      pricePerUnit: 420,
      quantity: 11,
    },
    {
      type: 'text',
      content:
        '[{"children":[{"text":"CMS is required for app owners in order to manage specific app content: static content, user management, sending push notifications, etc.","italic":true}],"type":"paragraph"}]',
    },

    {
      title: 'Project Management, Testing and Support',
      type: 'heading',
      subtitle:
        'Deliverables tracking, communication with the client, feature and pre-release testing and support for deployment, app design and app issues.',
    },
    {
      discount: 0,
      quantity: 10,
      pricePerUnit: 420,
      unit: {
        id: 'Iz7f2nZwe8sm9QLfiuv9',
        name: 'Day',
        index: 12,
      },
      type: 'service',
      service: {
        id: 'E53WK0bM02fUweXzdVKi',
        name: 'Project Management',
        createdAt: +new Date(),
      },
      content:
        '[{"children":[{"text":"Project implementation","bold":true}],"type":"paragraph"},{"children":[{"children":[{"text":"Communication with the client"}],"type":"li"},{"type":"li","children":[{"text":"Synchronization with development and design team"}]},{"type":"li","children":[{"text":"Timeline planning (Design, implementation, testing and deployment plan)"}]}],"type":"ul"},{"children":[{"text":""}],"type":"paragraph"},{"type":"paragraph","children":[{"text":""}]}]',
    },
    {
      unit: {
        id: 'Iz7f2nZwe8sm9QLfiuv9',
        name: 'Day',
        index: 13,
      },
      type: 'service',
      pricePerUnit: 420,
      discount: 0,
      content:
        '[{"type":"paragraph","children":[{"bold":true,"text":"Mobile app testing"}]},{"type":"ul","children":[{"children":[{"text":"Device testing"}],"type":"li"},{"type":"li","children":[{"text":"Functionality testing"}]},{"children":[{"text":"User Acceptance Testing"}],"type":"li"}]}]',
      service: {
        name: 'Testing',
        id: 'NJNuCjqmvEbnilNwbwo7',
        createdAt: +new Date(),
      },
      quantity: 5,
    },
    {
      discount: 0,
      pricePerUnit: 420,
      quantity: 2,
      unit: {
        id: 'Iz7f2nZwe8sm9QLfiuv9',
        name: 'Day',
        index: 14,
      },
      content:
        '[{"children":[{"children":[{"text":"1 month of free support (small bug fixes and maintenance)"}],"type":"li"},{"children":[{"text":"App Certificate management"}],"type":"li"},{"children":[{"text":"App publishing"}],"type":"li"}],"type":"ul"}]',
      service: {
        id: 'lBEyYhOaHsKbLyyneCog',
        name: 'Technical Support',
        createdAt: +new Date(),
      },
      type: 'service',
    },
    {
      type: 'text',
      content:
        '[{"type":"paragraph","children":[{"text":"NOTE","bold":true}]},{"children":[{"text":"The operating costs may deviate by up to 20% due to changes and increased scope of work (new functionalities, changes, etc.) compared to the initial specification by the client. In this case, the client will be notified and subsequent items will be added to the offer and sent to the client for approval."}],"type":"paragraph"}]',
    },
  ],
  imageUrl: null,
  totalDiscount: {
    discount: 0,
    discountType: 'absolute',
  },
  responseStatus: 'allowed',
  servicePricesVisibility: 'visible',
};
